/**
 * TanStack Query hooks for `white-label-tracking-domain-cname-with-ssl`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	whiteLabelTrackingDomainCnameWithSslQueryKeys,
	type CreateWhiteLabelTrackingDomainCnameWithSslBody,
	type ListWhiteLabelTrackingDomainCnameWithSslResponse,
	type WhiteLabelTrackingDomainCnameWithSslRow,
} from "./api";

export function useWhiteLabelTrackingDomainCnameWithSslList(): UseQueryResult<ListWhiteLabelTrackingDomainCnameWithSslResponse, Error> {
	return useQuery({
		queryKey: whiteLabelTrackingDomainCnameWithSslQueryKeys.list(),
		queryFn: list,
	});
}

export function useWhiteLabelTrackingDomainCnameWithSslCreate(): UseMutationResult<WhiteLabelTrackingDomainCnameWithSslRow, Error, CreateWhiteLabelTrackingDomainCnameWithSslBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: whiteLabelTrackingDomainCnameWithSslQueryKeys.all });
		},
	});
}

export function useWhiteLabelTrackingDomainCnameWithSslDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: whiteLabelTrackingDomainCnameWithSslQueryKeys.all });
		},
	});
}
